import React from 'react';
import CannyWidget from '../../components/canny/canny-widget';

const Canny = () => {
  return <CannyWidget />;
};

export default Canny;
